module.exports = __webpack_public_path__ + "static/media/dmp_icon_font.bf176cb2.ttf";